import type { ReactNode } from 'react';
import styled from 'styled-components';

import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled.div`
  container-type: inline-size;
`;

const Separator = styled.div`
  width: 1px;
  grid-area: separator;
  background-color: var(--c-nd-150);
`;

const Root = styled.div`
  display: grid;
  gap: var(--triple-unit);
  grid-template-areas:
    'myCards'
    'myLineups'
    'topPlayers';
  grid-template-columns: 1fr;

  ${Separator} {
    display: none;
  }

  --container-padding: var(--intermediate-unit);
  padding: var(--container-padding);

  @media ${laptopAndAbove} {
    --container-padding: var(--triple-unit);

    @container (width > 900px) {
      grid-template-areas:
        'myCards separator topPlayers'
        'myLineups separator topPlayers';
      grid-template-columns: 1fr auto 1fr;

      ${Separator} {
        display: initial;
      }
    }
  }
`;

type Props = {
  myCards: ReactNode;
  myLineups?: ReactNode;
  topPlayers: ReactNode;
};
export const PlayersPageLayout = ({
  myCards,
  myLineups,
  topPlayers,
}: Props) => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <Wrapper>
      <Root>
        <div style={{ gridArea: 'myCards' }}>{myCards}</div>
        <div style={{ gridArea: 'myLineups' }}>{myLineups}</div>
        {!!isLaptopAndAbove && <Separator />}
        <div style={{ gridArea: 'topPlayers' }}>{topPlayers}</div>
      </Root>
    </Wrapper>
  );
};
